import { Login } from "@components/Login";
import { Alert } from "@mui/material";
import version from "build.json";
import Head from "next/head";

const getEnvLabel = () => {
    if (typeof window !== "undefined") {
        const host = window.location.hostname;
        if (host === "admin.staging.talkuccino.com") return "Stage";
        if (host === "admin.talkuccino.com") return "Prod";
    }
    if (process.env.NODE_ENV === "development") return "Local";
    return "unknown";
};

const LoginComponent = () => {
    const envLabel = getEnvLabel();

    return (
        <div>
            <Head>
                <title>Talkuccino</title>
                <meta name="description" content="Talkuccino" />
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <main>
                <Login />
            </main>

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "-50px",
                }}
            >
                <Alert variant="outlined" severity="info" style={{ padding: "0 20px", border: "0", fontWeight: "500" }}>
                    {envLabel}: {version.version}
                </Alert>
            </div>
        </div>
    );
};

export default LoginComponent;
